import {LoginPageDynamic} from "../src/admin/login/LoginPageDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

const config = [{reactDynamic: "login-page", view: <LoginPageDynamic />}];

(() => prepareHydratedApp(config))();
